import { t } from "@travily/i18n";
import { Wizard } from "@ui/components/Wizard";
import type { ReactNode } from "react";
import { DescriptionField, descriptionFieldCopy } from "@/components/ListingFields/DescriptionField";

const COLOR = "green" as const;
const LISTING_TYPE = "product" as const;

export interface ProductDescriptionStepViewProps {
  /** Wizard progress: 1-based index of the current stage. */
  currentStage: number;
  /** Wizard progress: total number of stages. */
  totalStages: number;
  /** Navigate to the previous stage. Omit to hide the back button. */
  onBack?: () => void;
  /** Top-bar tertiary actions (e.g. "Questions?", "Finish later"). */
  topBarActions: ReactNode;
  /** Advance to / submit the current stage. */
  onPrimary: () => void;
  /** Whether the primary button shows a pending spinner. */
  primaryPending: boolean;
  /** Current description, as HTML. */
  description: string;
  /** Field error for the description, or undefined when valid. */
  error?: string;
  /** Called with the new HTML on every change. */
  onDescriptionChange: (html: string) => void;
}

export function ProductDescriptionStepView({
  currentStage,
  totalStages,
  onBack,
  topBarActions,
  onPrimary,
  primaryPending,
  description,
  error,
  onDescriptionChange,
}: ProductDescriptionStepViewProps) {
  const { heading, helper } = descriptionFieldCopy(LISTING_TYPE);

  return (
    <Wizard color={COLOR} currentStage={currentStage} totalStages={totalStages} onBack={onBack}>
      {topBarActions}
      <Wizard.PrimaryButton onPress={onPrimary} isPending={primaryPending}>
        {t("common.actions.continue")}
      </Wizard.PrimaryButton>
      <Wizard.Stage heading={heading} helper={helper}>
        <div className="flex w-full flex-1 flex-col [&>*]:flex-1">
          <DescriptionField
            error={error}
            listingType={LISTING_TYPE}
            onChange={onDescriptionChange}
            value={description}
          />
        </div>
      </Wizard.Stage>
    </Wizard>
  );
}
